import {
  HotelBookType,
  HOTEL_BOOK_TYPE,
} from "redmond";

import * as H from "history";
import queryStringParser from "query-string";

export interface HotelBookParsedQuery {
  [HOTEL_BOOK_TYPE]: HotelBookType;
  bookStep?: string;
}

export const parseQueryFromString = (
  queryString: string
): HotelBookParsedQuery => {
  const parsedQueryStringPrimitive = queryStringParser.parse(queryString);
  return {
    [HOTEL_BOOK_TYPE]: parsedQueryStringPrimitive[
      HOTEL_BOOK_TYPE
    ] as HotelBookType,
    bookStep: parsedQueryStringPrimitive.bookStep as string,
  };
};

export const parseQueryString = (history: H.History): HotelBookParsedQuery => {
  const queryString = history?.location?.search || "";
  return parseQueryFromString(queryString);
};
